<!-- <div class="bot-container"> -->
<!-- Bot button/icon goes here -->
<!-- <button *ngIf="!isOpen && showChatbot" class="chatbot-fab" (click)="openChatbot()" aria-label="Open chatbot">
  <img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" />
</button> -->

<button *ngIf="!isOpen && showChatbot" class="chatbot-fab" (mousedown)="onFabMouseDown($event)" (click)="openChatbot()"
  [ngStyle]="position.left !== null && position.top !== null ? { left: position.left + 'px', top: position.top + 'px', position: 'fixed', zIndex: 2147483647 } : {}"
  aria-label="Open chatbot">
  <img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" />
</button>

<div class="chat-container" #chatContainer *ngIf="isOpen && showChatbot" [ngClass]="{ 'minimized': isMinimized }"
  [ngStyle]="{ top: position.top + 'px', left: position.left + 'px' }">

  <div class="chat-header" (mousedown)="onHeaderMouseDown($event)">
    <span class="title"><img src="assets/chatbot.png" alt="Chatbot" style="width:32px; height:32px;" /> CDS
      Assistant</span>
    <!-- <span class="title" [ngClass]="{ 'minimized-title': isMinimized }" *ngIf="selectedChatbotFlow !== 'none'"> <button class="controls go-back-btn"
         (click)="goBackToFlowSelection()" title="Click to switch flow"><svg width="22" height="22"
          viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 3.3L2 11h2v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9h2L12 3.3zM9 21v-6h6v6H9z" />
        </svg>
      </button>
      CDS Assistant
      <span *ngIf="selectedChatbotFlow === 'rule'">(Rule Based)</span>
      <span *ngIf="selectedChatbotFlow === 'genai'">(Gen AI Based)</span>
    </span> -->
    <div class="controls">
      <button *ngIf="!isMinimized" (click)="toggleMinimize()" title="Minimize">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
      <button *ngIf="isMinimized" (click)="toggleMinimize()" title="Maximize">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 3 3 3 3 9"></polyline>
          <polyline points="15 21 21 21 21 15"></polyline>
          <line x1="21" y1="3" x2="14" y2="10"></line>
          <line x1="3" y1="21" x2="10" y2="14"></line>
        </svg>
      </button>
      <button (click)="closeChatbot()" title="Close">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
          <line x1="4" y1="4" x2="20" y2="20"></line>
          <line x1="20" y1="4" x2="4" y2="20"></line>
        </svg>
      </button>
    </div>
  </div>

  <div class="tab-navigation" *ngIf="!isMinimized">
    <button class="tab-btn" [class.active]="selectedChatbotFlow === 'genai'" (click)="selectChatbotFlow('genai')" *ngIf="IsGenaiChatbotEnabledd">
      Ask a question
    </button>
    <button class="tab-btn" [class.active]="selectedChatbotFlow === 'rule'" (click)="selectChatbotFlow('rule')">
      Perform Actions
    </button>
  </div>

  <!-- <div *ngIf="selectedChatbotFlow === 'none' && !isMinimized" class="chatbot-experience-selection">
    <div class="experience-title"><b>Select Your Chatbot Experience</b></div>
    <div class="experience-tiles">
      <div class="experience-tile" (click)="selectChatbotFlow('rule')">
        <div class="tile-content">
          <img src="assets/rb.png" alt="Rule-Based" class="tile-icon" />
          <div>
            <div class="tile-title"><b>Rule-Based Flow</b></div>
            <div class="tile-desc">For quick, predictable answers and guided interactions.</div>
          </div>
        </div>
      </div>
      <div class="experience-tile" (click)="selectChatbotFlow('genai')">
        <div class="tile-content">
          <img src="assets/ai.png" alt="Gen AI" class="tile-icon" />
          <div>
            <div class="tile-title"><b>Gen AI Based Flow</b></div>
            <div class="tile-desc">For creative, dynamic conversations. Powered by advanced AI.</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->



  <ng-container>



    <div class="chat-messages" #chatWindow [appLoading]="isLoading" [loaderColor]="loaderBgType"
      [fixedLoader]="fixedLoader" *ngIf="!isMinimized">

      <div *ngFor="let message of messages; trackBy: trackByMessageIndex"
        [ngClass]="{ bot: message.sender === 'bot', user: message.sender === 'user' }" class="message">
        <span *ngIf="message.text">
          <div class="ai-response" [innerHTML]="message.safeHtml ? message.safeHtml : message.text"></div>
          <a *ngIf="message.html" href="javascript:void(0)" (click)="openScenario()">{{ message.html }}</a>
        </span>

        <div class="response-feedback" *ngIf="selectedChatbotFlow === 'genai' && message.type === 'aiResponse' && message.feedback">
          <button type="button" class="response-feedback__toggle" (click)="toggleResponseFeedback(message)"
            [attr.aria-expanded]="!!message.feedback.open" [attr.aria-controls]="'feedback-panel-' + message.responseId"
            [attr.aria-label]="message.feedback.saved ? 'Send feedback: edit feedback for this answer' : 'Send feedback for this answer'"
            [title]="message.feedback.saved ? 'Edit feedback' : 'Send feedback'">
            <span class="response-feedback__toggle-label">Send feedback</span>
            <span class="zs-icon zs-icon-chat" [class.zs-icon-chat-fill]="message.feedback.saved" aria-hidden="true"></span>
          </button>
          <div class="response-feedback__panel" *ngIf="message.feedback.open" [id]="'feedback-panel-' + message.responseId">
          <fieldset class="response-feedback__ratings" [disabled]="message.feedback.saving">
            <legend>Rate this answer</legend>
            <div class="response-feedback__scale">
              <label *ngFor="let rating of feedbackRatings" [class.selected]="message.feedback.rating >= rating"
                [title]="rating === 1 ? '1 - Not helpful' : rating === 5 ? '5 - Very helpful' : rating + ' out of 5'">
                <input type="radio" [name]="'feedback-' + message.responseId" [value]="rating"
                  [(ngModel)]="message.feedback.rating" (ngModelChange)="feedbackChanged(message)"
                  [attr.aria-label]="rating + ' out of 5'">
                <span class="zs-icon zs-icon-star" [class.zs-icon-star-fill]="message.feedback.rating >= rating" aria-hidden="true"></span>
              </label>
            </div>
            <div class="response-feedback__endpoints"><span>Not helpful</span><span>Very helpful</span></div>
          </fieldset>
          <ng-container *ngIf="message.feedback.rating">
            <label class="response-feedback__comment-label" [for]="'feedback-comment-' + message.responseId">Comment (optional)</label>
            <textarea [id]="'feedback-comment-' + message.responseId" rows="2" maxlength="2000"
              [(ngModel)]="message.feedback.comment" (ngModelChange)="feedbackChanged(message)"
              [disabled]="message.feedback.saving" [attr.aria-describedby]="'feedback-status-' + message.responseId"></textarea>
            <div class="response-feedback__actions">
              <button type="button" (click)="submitResponseFeedback(message)"
                [disabled]="message.feedback.saving || isFeedbackUnchanged(message)">
                {{ message.feedback.saving ? 'Saving...' : message.feedback.saved ? 'Update feedback' : 'Submit feedback' }}
              </button>
              <span class="response-feedback__count">{{ message.feedback.comment.length }}/2000</span>
            </div>
          </ng-container>
          <p class="response-feedback__status" [class.response-feedback__status--error]="message.feedback.error"
            [id]="'feedback-status-' + message.responseId" role="status" aria-live="polite">
            {{ message.feedback.error || (message.feedback.saving ? 'Saving feedback...' : isFeedbackUnchanged(message) ? 'Feedback saved. Thank you.' : '') }}
          </p>
          </div>
        </div>

        <div *ngIf="message.options" class="options">
          <button *ngFor="let option of message.options" (click)="handleOptionClick(option)" [disabled]="isThinking">
            {{ option }}
          </button>
        </div>

        <!-- Create Scenario: one conditional card in place of the old 6-8 question chain.
             Brand/channel only render on the new-project path; on the existing-project path they
             are read back off the chosen project instead of being asked for. -->
        <!-- Once submitted the card freezes into a read-only record of what was sent, so it stays
             accurate even if the form is used again later in the same conversation. -->
        <div *ngIf="message.type === 'createScenarioForm' && message.submitted" class="cs-form cs-form--done">
          <div class="cs-form__row cs-form__row--readonly cs-form__summary">
            <span><strong>{{ message.summary.path }}:</strong> {{ message.summary.projectName }}</span>
            <span><strong>Scenario:</strong> {{ message.summary.scenarioName }}</span>
            <span><strong>Product:</strong> {{ message.summary.product }}</span>
            <span><strong>Channel:</strong> {{ message.summary.channel }}</span>
            <span><strong>Payer:</strong> {{ message.summary.payer }}</span>
            <span><strong>Contract:</strong> {{ message.summary.contractStartDate }} &rarr; {{ message.summary.contractEndDate }}</span>
          </div>
        </div>

        <div *ngIf="message.type === 'createScenarioForm' && !message.submitted" class="cs-form"
          [class.cs-form--done]="createFormDone">

          <div class="cs-form__title">New scenario</div>

          <div class="cs-form__row cs-form__row--inline">
            <label class="cs-form__label">Project</label>
            <div class="cs-form__pills">
              <label class="cs-radio">
                <input type="radio" name="csPath" [value]="false" [(ngModel)]="createForm.isNewProject"
                  (ngModelChange)="onCreateFormPathChange()" [disabled]="createFormDone">
                <span>Existing</span>
              </label>
              <label class="cs-radio">
                <input type="radio" name="csPath" [value]="true" [(ngModel)]="createForm.isNewProject"
                  (ngModelChange)="onCreateFormPathChange()" [disabled]="createFormDone">
                <span>New</span>
              </label>
            </div>
          </div>

          <!-- Existing project -->
          <ng-container *ngIf="!createForm.isNewProject">
            <div class="cs-form__row">
              <label class="cs-form__label" for="csProjectExisting">Name</label>
              <select id="csProjectExisting" [(ngModel)]="createForm.projectName"
                (ngModelChange)="onCreateFormProjectSelected()" [disabled]="createFormDone">
                <option value="">Select a project</option>
                <option *ngFor="let p of allProjectNames" [value]="p">{{ p }}</option>
              </select>
              <small class="cs-form__error" *ngIf="createFormErrors.projectName">{{ createFormErrors.projectName }}</small>
            </div>
            <div class="cs-form__row cs-form__row--readonly" *ngIf="createForm.product || createForm.channel">
              <span class="cs-form__label">Inherited</span>
              <span class="cs-form__auto">
                <b>{{ createForm.product || '—' }}</b> · <b>{{ createForm.channel || '—' }}</b>
              </span>
            </div>
          </ng-container>

          <!-- New project -->
          <ng-container *ngIf="createForm.isNewProject">
            <div class="cs-form__row">
              <label class="cs-form__label" for="csProjectNew">Name</label>
              <input id="csProjectNew" [(ngModel)]="createForm.projectName" [disabled]="createFormDone"
                placeholder="New project name">
              <small class="cs-form__error" *ngIf="createFormErrors.projectName">{{ createFormErrors.projectName }}</small>
            </div>
            <div class="cs-form__row">
              <label class="cs-form__label" for="csBrand">Brand</label>
              <select id="csBrand" [(ngModel)]="createForm.product" (ngModelChange)="onCreateFormBrandChange()"
                [disabled]="createFormDone">
                <option value="">Select a brand</option>
                <option *ngFor="let b of createFormBrands" [value]="b.brand">{{ b.brand }}</option>
              </select>
              <small class="cs-form__error" *ngIf="createFormErrors.product">{{ createFormErrors.product }}</small>
            </div>
            <div class="cs-form__row">
              <label class="cs-form__label" for="csChannel">Channel</label>
              <select id="csChannel" [(ngModel)]="createForm.channel" (ngModelChange)="onCreateFormChannelChange()"
                [disabled]="createFormDone">
                <option value="">Select a channel</option>
                <option *ngFor="let c of createFormChannels" [value]="c">{{ c }}</option>
              </select>
              <small class="cs-form__error" *ngIf="createFormErrors.channel">{{ createFormErrors.channel }}</small>
            </div>
          </ng-container>

          <!-- Common to both paths -->
          <div class="cs-form__row">
            <label class="cs-form__label" for="csScenario">Scenario</label>
            <input id="csScenario" [(ngModel)]="createForm.scenarioName" [disabled]="createFormDone"
              placeholder="New scenario name">
            <small class="cs-form__error" *ngIf="createFormErrors.scenarioName">{{ createFormErrors.scenarioName }}</small>
          </div>

          <div class="cs-form__row">
            <label class="cs-form__label">Contract</label>
            <p-is-zs-month-range-picker #csDateRange class="zs-action-field zs-month-range-picker cs-form__range"
              (change)="onCreateFormDateChange()"></p-is-zs-month-range-picker>
            <small class="cs-form__hint" *ngIf="createForm.contractStartDate && createForm.contractEndDate">
              {{ createForm.contractStartDate }} &rarr; {{ createForm.contractEndDate }}
            </small>
            <small class="cs-form__error" *ngIf="createFormErrors.contractPeriod">{{ createFormErrors.contractPeriod }}</small>
          </div>

          <div class="cs-form__row">
            <label class="cs-form__label" for="csPayer">Payer</label>
            <select id="csPayer" [(ngModel)]="createForm.payer"
              [disabled]="createFormDone || createFormLoadingPayers || !createFormPayers.length">
              <option value="">{{ payerPlaceholder }}</option>
              <option *ngFor="let p of createFormPayers" [value]="p">{{ p }}</option>
            </select>
            <small class="cs-form__error" *ngIf="createFormErrors.payer">{{ createFormErrors.payer }}</small>
          </div>

          <div class="cs-form__actions" *ngIf="!createFormDone">
            <button class="cs-form__cancel" (click)="cancelCreateScenarioForm()" [disabled]="createFormSubmitting">
              Cancel
            </button>
            <button class="cs-form__submit" (click)="submitCreateScenarioForm()" [disabled]="createFormSubmitting">
              {{ createFormSubmitting ? 'Creating…' : 'Create scenario' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Modern typing indicator instead of a spinner + label -->
      <div *ngIf="isThinking" class="message bot">
        <span class="typing-indicator">
          <i></i><i></i><i></i>
        </span>
      </div>

    </div>


    <div class="chat-input" *ngIf="!isMinimized ">
      <div class="autocomplete-wrapper">
        <!-- Ghost suggestion layer -->
        <!-- <div class="ghost-suggestion">
                <span class="typed">{{ userInput }}</span><span class="suggested">{{ projectNameSuggestion }}</span>
              </div> -->
        <!-- Actual input -->
        <!-- input/keydown are bound natively (outside Angular's zone) in ngAfterViewInit, not via
             (ngModelChange)/(keydown) here -- see bot.component.ts for why. [value] is one-way so
             programmatic updates (selectProjectName, resetChat, etc.) still show up. -->
        <input #projectNameInput id="projectNameInput" [value]="userInput" placeholder="Type here......"
          autocomplete="off" [disabled]="step === 0 || isCreateFormOpen" />
        <ul *ngIf="showDropdown" class="project-dropdown">
          <li *ngFor="let name of filteredProjectNames" (click)="selectProjectName(name)">
            {{ name }}
          </li>
        </ul>
      </div>
      <button class="send" (click)="handleUserInput()" [disabled]="!isValidFormat() || step === 0 || isThinking">
        <span>Send</span>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M2 21l21-9L2 3v7l15 2-15 2z"></path>
        </svg>
      </button>
      <button class="reset" (click)="selectedChatbotFlow == 'rule' ?  resetChat() : resetgenaiChat()"
        [disabled]="isThinking">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12a9 9 0 1 0 3-6.7"></path>
          <polyline points="3 3 3 8 8 8"></polyline>
        </svg>
        <span>Reset</span>
      </button>
      <div *ngIf="validationError" class="input-error">{{ validationError }}</div>

    </div>
    <p class="chat-disclaimer" *ngIf="!isMinimized">
      {{ chatbotDisclaimerText }}
    </p>
    <!-- Modern Gen AI sub-flow selection tiles, shown only in Gen AI flow and no sub-flow selected -->
    <div class="genai-subflow-toggles" *ngIf="selectedChatbotFlow === 'genai' && !isMinimized">
      <button class="subflow-toggle-btn" [class.active]="selectedGenAiSubFlow === 'websearch'"
        (click)="selectGenAiSubFlow('websearch')" title="Web Search Flow" aria-label="Web Search Flow">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <path d="M12 2a15 15 0 0 1 0 20"></path>
          <path d="M12 2a15 15 0 0 0 0 20"></path>
        </svg>
      </button>
      <button class="subflow-toggle-btn" [class.active]="selectedGenAiSubFlow === 'generic'"
        (click)="selectGenAiSubFlow('generic')" title="Generic Gen AI Flow" aria-label="Generic Gen AI Flow">
        ✨
      </button>
    </div>

    <div class="modal-overlay" *ngIf="showScenarioModal"></div>
    <div class="scenario-modal" *ngIf="showScenarioModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ getScenarioSelectionLabel(modalAction) }}</h5>
          <button class="close-btn" (click)="closeScenarioModaloncancel()">✖</button>
        </div>
        <div class="modal-search-row">
          <label class="select-all" *ngIf="modalAction !== 'duplicate'">
            <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="toggleSelectAll()" />
            <span>Select All</span>
          </label>
          <input type="text" class="scenario-search" [class.full-width]="modalAction === 'duplicate'"
            [(ngModel)]="scenarioSearch" (ngModelChange)="filterScenarios()" placeholder="Search scenario..."
            autocomplete="off" />
        </div>
        <div class="scenario-list grid-list">
          <div class="grid-col">
            <div *ngFor="let scenario of pagedScenarios.slice(0, pageSize / 2); let i = index" class="scenario-row">
              <label>
                <!-- <input type="checkbox" [(ngModel)]="scenario.selected" (change)="onScenarioCheckChange()" /> -->
                <input type="checkbox" [checked]="scenario.selected" (change)="onScenarioCheckChange(i)"
                  [disabled]="isScenarioCheckboxDisabled(scenario)" />
                <span [title]="scenario.ScenarioName || scenario.name">
                  {{ scenario.ScenarioName || scenario.name }}
                </span>
              </label>
            </div>
          </div>
          <div class="grid-col">
            <div *ngFor="let scenario of pagedScenarios.slice(pageSize / 2, pageSize); let i = index"
              class="scenario-row">
              <label>
                <input type="checkbox" [checked]="scenario.selected"
                  (change)="onScenarioCheckChange(i + (pageSize / 2))"
                  [disabled]="isScenarioCheckboxDisabled(scenario)" />
                <span [title]="scenario.ScenarioName || scenario.name">
                  {{ scenario.ScenarioName || scenario.name }}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="pagination-actions" *ngIf="totalPages > 1">
          <span class="pagination-info">
            Showing {{ (currentPage - 1) * pageSize + 1 }}-{{ getEndIndex() }} of {{ scenarioList.length }}
          </span>
          <a class="pagination-link" (click)="goToPage(1)" [class.disabled]="currentPage === 1">&laquo;</a>
          <a class="pagination-link" (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 1">&lt;</a>
          <ng-container *ngFor="let page of paginationPages">
            <a class="pagination-link" [class.active]="page === currentPage" (click)="goToPage(page)">
              {{ page }}
            </a>
          </ng-container>
          <a class="pagination-link" (click)="goToPage(currentPage + 1)"
            [class.disabled]="currentPage === totalPages">&gt;</a>
          <a class="pagination-link" (click)="goToPage(totalPages)"
            [class.disabled]="currentPage === totalPages">&raquo;</a>
        </div>
        <div class="modal-actions">
          <button class="modal-btn small primary" (click)="handleScenarioAction()"
            [disabled]="isDeleteOrRefreshDisabled()">
            {{ modalAction === 'delete' ? 'Delete' : (modalAction === 'export' ? 'Export' : (modalAction === 'duplicate'
            ?
            'Duplicate' : 'Refresh')) }}
          </button>
          <button class="modal-btn small" (click)="closeScenarioModaloncancel()">Cancel</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" *ngIf="showConfirmModal"></div>
    <div class="scenario-modal" *ngIf="showConfirmModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ pendingAction === 'delete' ? 'Confirm Delete' : 'Confirm Refresh' }}
          </h5>
          <button class="close-btn" (click)="closeConfirmModal()">✖</button>
        </div>
        <div style="margin: 18px 0;">
          Are you sure you want to {{ pendingAction }} the selected scenarios?
        </div>
        <div class="modal-actions">
          <button class="modal-btn small primary" (click)="confirmWarningYes()">Yes</button>
          <button class="modal-btn small" (click)="closeConfirmModal()">No</button>
        </div>
      </div>
    </div>

  </ng-container>


</div>